import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShield, FiLock, FiCheckCircle, FiMonitor } = FiIcons;

const PrivacyNotice = () => {
  const { t } = useLanguage();

  const features = [
    {
      icon: FiMonitor,
      title: t('localProcessing'),
      description: t('localProcessingDesc'),
      color: 'text-blue-600',
      bgColor: 'bg-blue-50'
    },
    {
      icon: FiLock,
      title: t('noUpload'),
      description: t('noUploadDesc'),
      color: 'text-green-600',
      bgColor: 'bg-green-50'
    },
    {
      icon: FiCheckCircle,
      title: t('instantDelete'),
      description: t('instantDeleteDesc'),
      color: 'text-purple-600',
      bgColor: 'bg-purple-50'
    }
  ];

  return (
    <motion.div
      className="bg-gradient-to-br from-slate-50 to-gray-100 rounded-xl p-6 mt-6 border border-gray-200 shadow-sm"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.5 }}
    >
      {/* 標題區 */}
      <div className="flex items-center gap-3 mb-6">
        <motion.div
          className="w-10 h-10 bg-gradient-to-br from-green-500 to-emerald-600 rounded-xl flex items-center justify-center shadow-md"
          whileHover={{ scale: 1.1, rotate: 5 }}
          transition={{ type: "spring", stiffness: 300 }}
        >
          <SafeIcon icon={FiShield} className="w-5 h-5 text-white" />
        </motion.div>
        <div>
          <h3 className="text-lg font-bold text-gray-800">
            {t('privacyProtection')}
          </h3>
          <p className="text-sm text-gray-600">
            {t('yourDataIsSafe')}
          </p>
        </div>
      </div>

      {/* 功能卡片網格 */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-5">
        {features.map((feature, index) => (
          <motion.div
            key={index}
            className={`${feature.bgColor} rounded-lg p-4 border border-gray-200`}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6 + index * 0.1 }}
            whileHover={{ y: -2, boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
          >
            <div className="flex items-start gap-3">
              <motion.div
                className={`w-8 h-8 ${feature.bgColor} rounded-lg flex items-center justify-center flex-shrink-0 border border-gray-200`}
                whileHover={{ rotate: 360 }}
                transition={{ duration: 0.6 }}
              >
                <SafeIcon icon={feature.icon} className={`w-4 h-4 ${feature.color}`} />
              </motion.div>
              <div className="flex-1 min-w-0">
                <h4 className="font-semibold text-gray-800 text-sm mb-1">
                  {feature.title}
                </h4>
                <p className="text-xs text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      {/* 底部說明 */}
      <motion.div
        className="bg-white/60 backdrop-blur-sm rounded-lg p-4 border border-gray-200"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.9 }}
      >
        <p className="text-sm text-gray-700 leading-relaxed text-center">
          <span className="font-semibold text-gray-800">{t('guaranteeTitle')}: </span>
          {t('privacyNotice')}
        </p>
      </motion.div>
    </motion.div>
  );
};

export default PrivacyNotice;